import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../root.model'

const slice = (state: RootState) => state.helios.commentaryActivity

export const selectCommentaryActivityCount = createSelector(slice, s => s.count)

export const selectCommentaryActivityBreakdown = createSelector(slice, s => ({
  count: s.count,
  openAssigned: s.openAssigned,
  tagged: s.tagged,
}))

export const selectCommentaryActivityLoading = createSelector(
  slice,
  s => s.loading,
)
